<template>
    <DialogFrame :show-dialog="confirmDialogStateStore.state.show"
                 :on-click-close="onCanceled"
                 :title="confirmDialogStateStore.state.title"
                 :width="600"
                 :height="150">
        <template v-slot:dialogContent>
            <div class="container">
                <div class="row mb-3">
                    <div class="col">{{ confirmDialogStateStore.state.message }}</div>
                </div>
                <div class="row justify-content-center">
                    <button class="col-4 mx-2 btn btn-secondary"
                            @click="onCanceled">キャンセル</button>
                    <button class="col-4 btn btn-info"
                            @click="onAffirmed">{{ confirmDialogStateStore.state.affirmativeText }}</button>
                </div>
            </div>
        </template>
    </DialogFrame>
</template>

<script lang="ts">

import DialogFrame from "./DialogFrame.vue";
import {confirmDialogStateStore} from "@/stores/confirm-dialog-state-store";
import {defineComponent} from "vue";

export default defineComponent({
    name: "ConfirmDialog",
    components: {DialogFrame},
    // watch: {
    //     show() {
    //         console.log(confirmDialogStateStore.state.title)
    //     }
    // },
    setup() {

        const onCanceled = () => {
            confirmDialogStateStore.commit("onConfirmed", {affirmed: false})
        }

        const onAffirmed = () => {
            confirmDialogStateStore.commit("onConfirmed", {affirmed: true})
        }

        // onMounted(() => {
        //     console.log(confirmDialogStateStore.state.title)
        // })

        return {
            confirmDialogStateStore,
            onCanceled,
            onAffirmed,
        }
    }
})
</script>

<style scoped>

</style>